import React from 'react';
import { useQuery } from 'react-query';
import Loading from '../../Shared/Loading';
import ServiceRow from './ServiceRow';

const ManageService = () => {

    const { data: manageservices, isLoading } = useQuery('allmyservices', () =>
        fetch(`https://stark-wildwood-35883.herokuapp.com/myservices`)
            .then(res => res.json())
    );

    if (isLoading) {
        return <Loading />
    }


    return (
        <div className='p-5 bg-slate-200 h-screen'>
            <div class="overflow-x-auto">
                <table class="table w-full">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Photo</th>
                            <th>Title</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            manageservices.map((service, index) =>
                                <ServiceRow
                                    key={service._id}
                                    index={index}
                                    service={service}
                                />)
                        }
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default ManageService;